var map = {
	"./image/account-bg.png": 3366,
	"./image/auth-bg.jpg": 335,
	"./image/captcha-def.png": 2045,
	"./image/def-image.png": 6964,
	"./image/def-logo.png": 7446,
	"./image/delete-bg.png": 9014,
	"./image/hd-logo.png": 4341,
	"./image/info-bg.png": 2781,
	"./image/profile-bg.jpg": 7752,
	"./image/profile-pattern.png": 9523,
	"./image/saa-iran.png": 9175,
	"./image/warning-bg.svg": 3545,
	"./index.d": 8283,
	"./index.d.ts": 8283,
	"./line-loader.gif": 9274,
	"./svg/cigarettes.svg": 8861,
	"./svg/def_image.svg": 2585,
	"./svg/disable-check.svg": 6521,
	"./svg/emptyChart.svg": 9231,
	"./svg/emtyUser.svg": 4960,
	"./svg/family.svg": 3198,
	"./svg/gallery-add.svg": 7174,
	"./svg/halfCircle.svg": 9801,
	"./svg/halfCircleRotated.svg": 3428,
	"./svg/hamrah-doctor-logo.svg": 2533,
	"./svg/hamrah-doctor.svg": 4151,
	"./svg/hd-logo.svg": 6694,
	"./svg/history.svg": 8314,
	"./svg/mediKianTech128.svg": 8291,
	"./svg/mediKianTech300.svg": 3203,
	"./svg/mediKianTech64.svg": 6950,
	"./svg/niroohaye-mosalah.svg": 8180,
	"./svg/profile-empty-avatar.svg": 5517,
	"./svg/saa-iran-logo-fill.svg": 8342,
	"./svg/saa-iran-logo.svg": 9732,
	"./svg/salamat.svg": 5763,
	"./svg/success-checked-grey.svg": 3017,
	"./svg/success-checked.svg": 9383,
	"./svg/surgery.svg": 2171,
	"./svg/tamin.svg": 7957,
	"./svg/warning.svg": 5334,
	"./svg/warningDanger.svg": 1235,
	"./svgComponents/EmptyBoxes": 9012,
	"./svgComponents/EmptyBoxes.tsx": 9012,
	"./svgComponents/EmptyForm": 7277,
	"./svgComponents/EmptyForm.tsx": 7277,
	"./svgComponents/EmptySchedule": 5644,
	"./svgComponents/EmptySchedule.tsx": 5644,
	"./svgComponents/EmptyVisits": 1835,
	"./svgComponents/EmptyVisits.tsx": 1835,
	"./svgComponents/HDLogo": 787,
	"./svgComponents/HDLogo.tsx": 787,
	"./svgComponents/accordionButtonIcon": 5513,
	"./svgComponents/accordionButtonIcon.tsx": 5513,
	"./svgComponents/animate/AdmissionAnimated": 5560,
	"./svgComponents/animate/AdmissionAnimated.tsx": 5560,
	"./svgComponents/animate/OrganizationsAnimated": 3447,
	"./svgComponents/animate/OrganizationsAnimated.tsx": 3447,
	"./svgComponents/animate/assignedDevicesCountAnimated": 5447,
	"./svgComponents/animate/assignedDevicesCountAnimated.tsx": 5447,
	"./svgComponents/animate/cardiologistAnimated": 2381,
	"./svgComponents/animate/cardiologistAnimated.tsx": 2381,
	"./svgComponents/animate/doctorCountAnimated": 4161,
	"./svgComponents/animate/doctorCountAnimated.tsx": 4161,
	"./svgComponents/animate/doctorsAnimated": 6075,
	"./svgComponents/animate/doctorsAnimated.tsx": 6075,
	"./svgComponents/animate/medicationItemsAnimated": 5736,
	"./svgComponents/animate/medicationItemsAnimated.tsx": 5736,
	"./svgComponents/animate/myAssignedDevicesCountAnimated": 2477,
	"./svgComponents/animate/myAssignedDevicesCountAnimated.tsx": 2477,
	"./svgComponents/animate/patientCountAnimated": 6829,
	"./svgComponents/animate/patientCountAnimated.tsx": 6829,
	"./svgComponents/animate/prescriptionAnimated": 37,
	"./svgComponents/animate/prescriptionAnimated.tsx": 37,
	"./svgComponents/animate/visitCountAnimated": 4111,
	"./svgComponents/animate/visitCountAnimated.tsx": 4111,
	"./svgComponents/ecg": 5047,
	"./svgComponents/ecg.tsx": 5047,
	"./svgComponents/icon/analytics": 3060,
	"./svgComponents/icon/analytics.tsx": 3060,
	"./svgComponents/icon/brokenVideoAdd": 1479,
	"./svgComponents/icon/brokenVideoAdd.tsx": 1479,
	"./svgComponents/icon/calendar": 5044,
	"./svgComponents/icon/calendar.tsx": 5044,
	"./svgComponents/icon/chart": 9112,
	"./svgComponents/icon/chart.tsx": 9112,
	"./svgComponents/icon/clock": 318,
	"./svgComponents/icon/clock.tsx": 318,
	"./svgComponents/icon/computerAnalytics": 8181,
	"./svgComponents/icon/computerAnalytics.tsx": 8181,
	"./svgComponents/icon/dashboardDiamond": 817,
	"./svgComponents/icon/dashboardDiamond.tsx": 817,
	"./svgComponents/icon/dashboardSquare": 529,
	"./svgComponents/icon/dashboardSquare.tsx": 529,
	"./svgComponents/icon/dashboardSquareDiagonal": 5660,
	"./svgComponents/icon/dashboardSquareDiagonal.tsx": 5660,
	"./svgComponents/icon/leftArrow": 1390,
	"./svgComponents/icon/leftArrow.tsx": 1390,
	"./svgComponents/icon/lobbyIcon": 4387,
	"./svgComponents/icon/lobbyIcon.tsx": 4387,
	"./svgComponents/icon/medicalKit": 7169,
	"./svgComponents/icon/medicalKit.tsx": 7169,
	"./svgComponents/icon/onlineStatusIcon": 3650,
	"./svgComponents/icon/onlineStatusIcon.tsx": 3650,
	"./svgComponents/icon/pills": 5708,
	"./svgComponents/icon/pills.tsx": 5708,
	"./svgComponents/icon/twoPerson": 465,
	"./svgComponents/icon/twoPerson.tsx": 465,
	"./svgComponents/thermometers": 2233,
	"./svgComponents/thermometers.tsx": 2233,
	"./svgComponents/triangle.svg": 3390,
	"./svgComponents/triangleBackground": 3374,
	"./svgComponents/triangleBackground.tsx": 3374,
	"./svgComponents/triangleWhite.svg": 5341,
	"./svgComponents/videoPageSvgs/EmtyUser": 6066,
	"./svgComponents/videoPageSvgs/EmtyUser.jsx": 6066,
	"./text-loader.gif": 4471,
	"./webp/auth-bg.webp": 1466,
	"./webp/dashboard-blue-bg.webp": 1801,
	"./webp/dashboard-darkblue-bg.webp": 6425,
	"./webp/dashboard-green-bg.webp": 6358,
	"./webp/dropdown-header-bg.webp": 7919
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;